import React, { PropTypes } from "react";
import { SelectInput } from "../../../../common/form";
import { FormattedMessage } from "react-intl";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ValidationUtils from "../../../../../utils/ValidationUtils";
import { BILLING_PERIOD_FORM_VALIDATION_RULES } from "./BillingPeriodFormValidationRules";
import * as dataActions from "../../../../../utils/data/dataActions";



class BillingPeriodForm extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        const { billingPeriods } = this.props;
        const currentDate = new Date();

        if(billingPeriods && billingPeriods.length > 0) {
            let closestDate = billingPeriods
                .filter(billingPeriod => billingPeriod.startDate > currentDate)
                .reduce((closest, billingPeriod) => (!closest || billingPeriod.startDate < closest.startDate) ? billingPeriod : closest, null);
            closestDate = !closestDate ? billingPeriods[0] : closestDate;
            this.props.changeFieldValue("BillingPeriod", "billingPeriodId", closestDate.value);
        }
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <Field
                    id="billingPeriodId"
                    name="billingPeriodId"
                    component={SelectInput}
                    options={this.props.billingPeriods}
                    required={true}
                    sortOptions={false}
                    label={
                        <span className="label-no-wrap">
                            <FormattedMessage id="invoices.form.billingPeriodModal.title" />
                        </span>
                    }
                />
            </form>
        );
    }
}

BillingPeriodForm.propTypes = {
    handleSubmit: PropTypes.func,
    billingPeriods: PropTypes.array,
    changeFieldValue: PropTypes.func,
};


function mapDispatchToProps(dispatch) {
    return {
      changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
      dataActions: bindActionCreators(dataActions, dispatch),
    };
  }
  

export default connect(null, mapDispatchToProps, null, {withRef: true})(
    reduxForm({
        form: "BillingPeriod",
        validate: (values) =>
            ValidationUtils.validate(
                values,
                BILLING_PERIOD_FORM_VALIDATION_RULES
            ),
    })(BillingPeriodForm));


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/BillingPeriodForm.js